export const playResultLookup: { [key: string]: string } = {
  Out: "Out(s)",
  Sacrifice: "Sacrifice",
  Single: "Single",
  Double: "Double",
  Triple: "Triple",
  HomeRun: "Home Run",
  Error: "Error",
  FieldersChoice: "FC",
  StrikeoutSwinging: "K",
  StrikeoutLooking: "ꓘ",
  Walk: "Walk",
};

export const pitchResultLookup: { [key: string]: string } = {
  InPlay: "In Play",
  StrikeSwinging: "Strike Sw",
  StrikeCalled: "Strike",
  BallCalled: "Ball",
  Foul: "Foul",
  FoulTip: "Foul Tip",
  HitByPitch: "HBP",
  CatchersInt: "CI",
};
